import { render, staticRenderFns } from "./TaskListForNoReal.vue?vue&type=template&id=289fbb8a&"
import script from "./TaskListForNoReal.vue?vue&type=script&lang=js&"
export * from "./TaskListForNoReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports